import mime from 'mime';

export const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

const getMimeType = (orig: string): string => {
	return mime.getType(orig) || orig;
};

export const getSheetTypes = (): string[] => {
	return [getMimeType('xls'), getMimeType('xlsx')];
};

export const getANPRTypes = (): string[] => {
	return [getMimeType('csv'), ...getSheetTypes()];
};

export const getXMLFileTypes = (): string[] => {
	return ['text/xml', 'application/xml'];
};

export const getUploadFileTypes = (): string[] => {
	return [...getSheetTypes(), ...getXMLFileTypes()];
};

export const getTextFileTypes = (): string[] => {
	return [getMimeType('txt'), getMimeType('csv'), getMimeType('md')];
};

export const convertFileFormatToText = (format: string): string => {
	return mime.getExtension(format)?.toLocaleUpperCase() || format;
};

export const getFileType = (orig: string): string => {
	return getMimeType(orig).split('/')[0];
};

export const getCurrentUrl = (): string => {
	return `${window.location.protocol}//${window.location.host}`;
};

export const sortArr = (arr: string[], direction: 'asc' | 'desc' = 'asc'): string[] => {
	return [...arr].sort((a, b) => (direction === 'desc' ? -1 : 1) * a.localeCompare(b));
};

export function sortRecord<T>(record: Record<string, T>, direction: 'asc' | 'desc' = 'asc'): Record<string, T> {
	const sortedKeys = sortArr(Object.keys(record), direction);

	return sortedKeys.reduce(
		(prev, key) => {
			prev[key] = record[key];
			return prev;
		},
		{} as Record<string, T>
	);
}

/**
 * Sanitise given string for use as a HTML, URL, etc
 * @param str any string
 * @returns sanitised string with non alphanumeric characters removed, spaces replaced with hyphens
 */
export const sanitiseString = (str: string): string => {
	return str
		.toLocaleLowerCase()
		.replaceAll(/[^(a-zA-z0-9 )]/g, '')
		.replaceAll(' ', '-');
};

export const recordsToCsv = (records: Record<string, string>[], headers: string[]): string => {
	let csvRows: string[] = [headers.join(',')];

	csvRows = csvRows.concat(
		records.map((record) => {
			return Object.values(record)
				.map((rec) => (rec ? String(rec).replaceAll(',', ';') : rec))
				.join(',');
		})
	);

	return csvRows.join('\n');
};
